import { Dialog, DialogContent, DialogTitle, DialogContentText, DialogActions, Button } from "@mui/material";
import { useEffect, useState } from "react";
import styles from "./prompts.module.css";
import { ArrowLeft, Plus, X } from "react-feather";
import { useAuth0 } from "@auth0/auth0-react";
import Loader from "../../../Loader";
import { toast } from "react-smart-toaster";
import Axios from "axios";
import PromptListing from "./components/PromptList";
import PromptAddEdit from "./components/PromptAddEdit";

const Prompts = (props) => {
  const [isShowAddEditForm, setIsShowAddEditForm] = useState(false);
  const [promptList, setPromptList] = useState([]);
  const [promptDetails, setPromptDetails] = useState(null);
  const [promptId, setPromptId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [openPromptDeleteModal, setOpenPromptDeleteModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const { getAccessTokenSilently } = useAuth0();

  const filteredPromptList = promptList.filter((prompt) =>
    `${prompt.title} ${prompt.description}`
      .toLowerCase()
      .includes(searchQuery.toLowerCase())
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        // setLoading(true);
        const url = process.env.REACT_APP_APPLICANT_API_URL + "v1/chat-prompts";
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
        const response = await Axios.get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        console.log("response.data.data", response.data.data);
        setPromptList(response.data.data); // Assume response.data is an array of data
        props.setPromptListForConversation(response.data.data);
        setPromptDetails(null);
        // setLoading(false);
      } catch (error) {
        toast.error(error?.response?.data?.message);
      } finally {
        // setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (props?.isPromptModalOpen) {
      setPromptDetails(null);
    }

    if (props?.isShowPromptAddForm) {
      handleAddEditForm(true);
    }
  }, [props?.isPromptModalOpen, props?.isShowPromptAddForm]);

  const handleSearch = (query) => {
    setSearchQuery(query);
  };

  const AddPrompts = async (formData) => {
    try {
      formData.property_id = process.env.REACT_APP_WESTONHALL_PROPERTY_ID;
      setLoading(true);
      const url = process.env.REACT_APP_APPLICANT_API_URL + "v1/chat-prompts";
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
      const response = await Axios.post(url, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      console.log("response", response.data);
      const newPrompt = response.data.data;
      toast.success(response.data.message);
      setPromptList((prevList) => [newPrompt, ...prevList]);
      props.setPromptListForConversation((prevList) => [
        newPrompt,
        ...prevList,
      ]);
      if (props?.isShowPromptAddForm) {
        handleCloseModal();
      }
      setIsShowAddEditForm(false);
    } catch (error) {
      setLoading(false);
      toast.error(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const updatePrompts = async (formData) => {
    try {
      setLoading(true);
      const url = process.env.REACT_APP_APPLICANT_API_URL + `v1/chat-prompts/${promptDetails?.id}`;
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
      const response = await Axios.put(url, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      console.log("response", response.data);
      const newPrompt = response.data.data;
      setPromptDetails(null);
      setIsShowAddEditForm(false);
      setPromptList((prevList) =>
        prevList.map((prompt) =>
          prompt.id === newPrompt.id ? newPrompt : prompt
        )
      );
      props.setPromptListForConversation((prevList) =>
        prevList.map((prompt) =>
          prompt.id === newPrompt.id ? newPrompt : prompt
        )
      );

      toast.success(response.data.message);
    } catch (error) {
      setLoading(false);
      toast.error(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const deletePrompts = async (formData) => {
    try {
      setLoading(true);
      const url = process.env.REACT_APP_APPLICANT_API_URL + `v1/chat-prompts/${promptId}`;
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
      const response = await Axios.delete(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      console.log("response", response.data);
      setPromptId(null);
      setOpenPromptDeleteModal(false);
      setPromptList((prevList) =>
        prevList.filter((prompt) => prompt.id !== promptId)
      );

      props.setPromptListForConversation((prevList) =>
        prevList.filter((prompt) => prompt.id !== promptId)
      );

      toast.success(response.data.message);
    } catch (error) {
      setPromptId(null);
      setLoading(false);
      toast.error(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const handleAddEditForm = (value) => {
    setIsShowAddEditForm(value);
    setPromptDetails(null);
  };

  const loaderHandler = (value) => {
    setLoading(value);
  };

  const handleCloseModal = () => {
    props?.hanldePromptModal(false); // Close the modal
    setIsShowAddEditForm(false);
  };

  const setDetails = (value) => {
    setPromptDetails(value);
    setIsShowAddEditForm(true);
  };

  return (<div>
    {/* <Loader /> */}
    <Dialog
      open={props?.isPromptModalOpen}
      fullWidth
      maxWidth="md"
      onClose={handleCloseModal}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="NewPopUp MobileForm"
    >
      {loading && <Loader />}
      {!isShowAddEditForm && (<PromptListing
        promptList={filteredPromptList}
        setDetails={setDetails}
        handleCloseModal={handleCloseModal}
        setIsShowAddEditForm={setIsShowAddEditForm}
        setPromptId={setPromptId}
        setOpenPromptDeleteModal={setOpenPromptDeleteModal}
        onSearch={handleSearch}
        searchQuery={searchQuery}
      />)}
      {isShowAddEditForm && (<PromptAddEdit
        promptDetails={promptDetails}
        handleAddEditForm={handleAddEditForm}
        handleCloseModal={handleCloseModal}
        AddPrompts={AddPrompts}
        updatePrompts={updatePrompts}
      />)}
    </Dialog>

    {/* Delete dialog */}

    <Dialog
      open={openPromptDeleteModal}
      fullWidth
      maxWidth="sm"
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="NewPopUp"
      onClose={(e) => {
        setOpenPromptDeleteModal(false);
        setPromptId(null);
      }}
    >
      <DialogTitle id="alert-dialog-title">
        Delete Prompt
        <button onClick={(e) => { setOpenPromptDeleteModal(false); setPromptId(null); }}>
          <X />
        </button>
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          className="ModalFormGroup"
          style={{ marginBottom: "0px", padding: "25px 0" }}
        >
          <label className="PopupBodyText">Are you sure you want to delete this item?</label>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button className="CancelPopupBU" onClick={(e) => { deletePrompts(); setOpenPromptDeleteModal(false); }}>
          Delete
        </Button>
        <Button className="SubmitPopupBU" onClick={(e) => { setOpenPromptDeleteModal(false); setPromptId(null); }}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  </div>);
};

export default Prompts;